/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Login_PromptInputs */



/**
* | output |
* | --- |
* | "Sign in to see your local community and officials." |
*
* @param {Community_Login_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_login_prompt = /** @type {((inputs?: Community_Login_PromptInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Login_PromptInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez-vous pour voir votre communauté locale et les officiels.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicia sesión para ver tu comunidad local y los oficiales.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Entre para ver sua comunidade local e os oficiais.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accedi per vedere la tua comunità locale e gli ufficiali.")
	return /** @type {LocalizedString} */ ("Sign in to see your local community and officials.")
});